import { letters } from "../../index";

function rotateLetters() {
  letters.forEach( (item) => {
    item.style.transform = `rotate(${Math.floor(Math.random() * 20) - 9}deg)`;
  });
}

export default rotateLetters;